/**
 * Operator / contact details already published on the legal pages.
 * Do not invent a new company entity — keep these aligned with the
 * existing footer and the prior Aura Technology policy text.
 */
export const LEGAL_OPERATOR_NAME = 'Aura Technology'

export const LEGAL_PRIVACY_OFFICER_NAME = 'James Daniels'

export const LEGAL_OPERATOR_ADDRESS_LINES = [
  '4707 Greenleaf Ct Suite A',
  'Modesto CA 95356',
] as const

export const LEGAL_EFFECTIVE_DATE = '26th day of December, 2023'

export const LEGAL_SITE_TYPE = 'Website for Geolocation'
